import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  IStateProps,
  IDispatchProps,
  IProps,
} from './interfaces';
import { StyledList, TeamIcon } from './styles';
import Button from '../../../../../../Shared/VaultButton';
import {
  DialogHeader,
  DialogHeaderTitle,
  DialogContentContainer,
  DialogActionsOverride,
  ActionContainer,
} from '../../../../../../Shared/styles/dialog';
import { IAppState } from '../../../../../../../state/reducers';
import { toggleNotFound } from '../../../../../../../state/exchange/searchResults';

class NotFound extends PureComponent<IProps> {
  render() {
    const {
      teams,
      teamsWithoutGames,
      onExit,
    } = this.props;
    const targets = teamsWithoutGames.sort().map((team) => teams.find(({ teamName }) => team === teamName));
    return (
      <>
        <DialogHeader>
          <DialogHeaderTitle>
            Teams Without Games ({teamsWithoutGames.length})
          </DialogHeaderTitle>
        </DialogHeader>
        <DialogContentContainer>
          <StyledList>
            {targets.map(({ teamName, teamImageFile }) => (
              <>
                <ListItem>
                  <ListItemIcon>
                    <TeamIcon
                      src={teamImageFile}
                    />
                  </ListItemIcon>
                  <ListItemText>
                    {teamName.toUpperCase()}
                  </ListItemText>
                </ListItem>
                <Divider />
              </>
            ))}
          </StyledList>
        </DialogContentContainer>
        <DialogActionsOverride disableSpacing>
          <ActionContainer>
            <Button
              variant="plainOnPaper"
              onClick={onExit}
            >
              Close
            </Button>
          </ActionContainer>
        </DialogActionsOverride>
      </>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  teams: state.exchange.searchParams.conferences
    .reduce((teams, conference) => [...teams, ...conference.teams], []),
});

const mapDispatchToProps: IDispatchProps = {
  onExit: toggleNotFound,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotFound);
